import { useState } from "react";
import { Link } from "react-router-dom";

export default function FallWinterSignature({
  title       = "Fall / Winter Signature",
  description = "Nature is the purest place.It exists everywhere, yet in a society increasingly surrounded by lifeless, artificial materials and the rush of modern time, this “pure place” we call nature seems to be drifting further away from us.Yet our hearts and bodies are always drawn toward nature. The desire to be closer to it—this “expression and self-expression”—is realized through each individual’s choice.This choice aligns with the values, awareness, and sense of responsibility of people of all ages, becoming a reflection of their lifestyle and what they truly care about.",
  imageSrc    = "/fall_winter.png",
  imageAlt    = "Fall Winter Signature Collection",
}) {
  return (
    <section className="w-full mt-10 sm:mt-16 lg:mt-2 flex flex-col items-center overflow-hidden">

      {/* ── Heading block ── */}
      <div className="w-full text-center px-6 pt-6 sm:pt-16 pb-4">

        {/* title */}
        <h2
          className="uppercase text-[#2c2520] m-0 mb-5"
          style={{
            fontFamily: "'Sustainability', sans-serif",
            fontSize: "clamp(20px, 1.875vw, 36px)",
            fontWeight: 400,
            lineHeight: "38px",
            letterSpacing: "0",
          }}
        >
          {title}
        </h2>

        {/* body copy */}
        <p
          className="text-[#000] max-w-[940px] mx-auto text-center"
          style={{ fontFamily: "Sustainability, sans-serif", fontWeight: 300, fontSize: "clamp(12px, 0.9375vw, 18px)", lineHeight: "32px" }}
        >
          {description}
        </p>
      </div>


      {/* ── Image ── */}
      {/* <div
        className="w-full max-w-[1100px] px-4 pt-4"
        style={{ aspectRatio: "1 / 1" }}
      >
        <img
          src={imageSrc}
          alt={imageAlt}
          onLoad={() => setImgLoaded(true)}
          className="w-full h-full object-cover object-top"
          style={{ opacity: imgLoaded ? 1 : 0, transition: "opacity 0.6s ease" }}
        />
      </div> */}

      {/* ── Discover more ── */}
      {/* <div className="pb-12 lg:pb-32">
        <Link
          to="/category/women"
          className="text-[#2c2520] hover:opacity-60 transition-opacity underline underline-offset-4 decoration-[#2c2520]/40 hover:decoration-[#2c2520]"
          style={{
            fontFamily: "Sustainability, sans-serif",
            fontWeight: 400,
            fontSize: "20px",
            lineHeight: "32px",
            letterSpacing: "0",
          }}
        >
          Discover more →
        </Link>
      </div> */}

    </section>
  );
}